import { createQueryKeyStore } from "@lukemorales/query-key-factory";

export const counselingCrowdStatusKeys = createQueryKeyStore({
  crowdStatus: {
    list: (pharmacyId: number[]) => [pharmacyId],
    detail: (id: number) => ["crowdStatusPublic", id],
  },
});
